import React from "react";
import { Collapsible, Button } from "react-materialize";
import DashboardDestinationContent from "./dashboardaccess/DashboardDestinationContent";
// import DashboardSaleContent from "./dashboardaccess/DashboardSaleContent";
import DashboardReportContent from "./dashboardaccess/DashboardReportContent";

export default function DashboardAccess({ userData, handleEvents }) {
  const boxName = "content-dashboardaccess";
  return (
    <div id="dashboardaccess-box" className="">
      <Collapsible accordion={false}>
        <DashboardDestinationContent
          boxName={boxName}
          userData={userData}
          handleEvents={handleEvents}
        />
        {/* <DashboardSaleContent
          boxName={boxName}
          userData={userData}
          handleEvents={handleEvents}
        /> */}
        <DashboardReportContent
          boxName={boxName}
          userData={userData}
          handleEvents={handleEvents}
        />
      </Collapsible>
      <div
        key={boxName + "-btn-save"}
        className={boxName + " row"}
        style={{ textAlign: "center", marginTop: "25px" }}
      >
        <Button
          className=""
          id="btn-save"
          node="button"
          waves="light"
          style={{ width: "150px" }}
          onClick={handleEvents.OnSave}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
